var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBanking = function SvgBanking(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.411 25",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.218 11.277H2.2c-.874 0-1.948-.323-2.16-.844a.645.645 0 0 1 .24-.718L11.243.405a1.434 1.434 0 0 1 2 0L24.135 9.72a.64.64 0 0 1 .239.717c-.212.519-1.284.84-2.156.84M12.209 4.828a1.837 1.837 0 1 0 1.837 1.837 1.84 1.84 0 0 0-1.837-1.837",
    className: "banking_svg__superlight",
    "data-name": "Differenzmenge 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.802 22.92v-9.76a.885.885 0 0 0-.885-.885H3.484a.885.885 0 0 0-.885.885v9.76h-.732a1.04 1.04 0 0 0-1.04 1.04A1.04 1.04 0 0 0 1.867 25h20.607a1.04 1.04 0 0 0 1.04-1.04 1.04 1.04 0 0 0-1.04-1.04Zm-2.08-6.635v6.637h-2.975v-6.637a1.6 1.6 0 0 1 1.407-1.735h.165a1.594 1.594 0 0 1 1.403 1.735m-6.115 0v6.637h-2.98v-6.637a1.6 1.6 0 0 1 1.407-1.735h.165a1.6 1.6 0 0 1 1.408 1.735m-7.52-1.735a1.6 1.6 0 0 1 1.407 1.735v6.637H4.679v-6.637a1.6 1.6 0 0 1 1.408-1.735",
    "data-name": "Pfad 4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBanking);
export default ForwardRef;